import * as pageStyles from "@/pages/InvoiceDetailPage.styles";
import * as shared from "@/styles/shared";
import { useTranslation } from "react-i18next";
import * as styles from "./invoiceDialogs.styles";

interface DeleteInvoiceDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  deleting?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const DeleteInvoiceDialog = ({ isOpen, title, message, deleting = false, onConfirm, onClose }: DeleteInvoiceDialogProps) => {
  const { t } = useTranslation("common");

  if (!isOpen) return null;

  return (
    <div className={styles.dialogOverlay} onClick={onClose}>
      <div className={styles.dialog} onClick={(e) => e.stopPropagation()}>
        <div className={styles.dialogHeader}>
          <h2 className={styles.dialogTitle}>{title}</h2>
          <p className={shared.muted}>{message}</p>
        </div>

        <div className={pageStyles.confirmButtonGroup}>
          <button type="button" onClick={onClose} disabled={deleting} className={pageStyles.secondaryButton}>
            {t("button.cancel")}
          </button>
          <button type="button" onClick={onConfirm} disabled={deleting} className={pageStyles.destructiveButton}>
            {t("button.delete")}
          </button>
        </div>
      </div>
    </div>
  );
};

export { DeleteInvoiceDialog, type DeleteInvoiceDialogProps };
